<template lang="pug">
vm-row.information__wrapper(vm-w="12" vm-type="flex" vm-justify="center")
  modal-sending-receptions(:sending_id='id')
  vm-col.card__wrapper(vm-sm=12 vm-md=6 vm-lg=12)
    .card.card-flex2
      .status__absolute(:style="`background-color: ${status_color}`")
        span {{ status_display_sendings }}
      .card-body
        vm-row(vm-w="12" vm-type="flex" vm-justify="center" class="heading_title")
          h4 Envios a Cliente:
            span  {{ customer  }}
        vm-table(max-height="350px" :data="sendings" class="table")
          template(slot="thead")
            vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('sending_receptions.' + column) }}
          template(slot-scope="{data}")
            vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
              vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                slot(v-if="column === 'parcel'") {{ data[indextr][column] }}
                slot(v-if="column === 'guide_number'") {{ data[indextr][column] }}
                slot(v-if="column === 'amount'") {{ data[indextr][column] | currency }}
                slot(v-if="column === 'shipping_date'") {{ data[indextr][column] | moment('DD-MMMM-YYYY') }}
                slot(v-if="column === 'created_by'") {{ data[indextr]['user'].name }}
                slot(v-if="column === 'actions'")
                  .actions__wrapper
                    vm-button(type="flat" icon="eye-outline" color="#026481" @click="showSendingDetails(data[indextr])")
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import ModalSendingReceptions from '@/components/modals/ModalSendingReceptions.vue'
const { mapGetters, mapActions } = createNamespacedHelpers('SendingReceptionInformation')

export default {
  name: 'SendingCustomerTable',
  components: {
    ModalSendingReceptions
  },
  props: {
    sale: {
      type: Object,
      default: () => {}
    }
  },
  data: () => ({
    columns: [
      'parcel',
      'guide_number',
      'amount',
      'shipping_date',
      'created_by',
      'actions'
    ],
    id: null
  }),
  computed: {
    ...mapGetters([]),
    sendings () {
      if (this.sale.sendings) {
        return this.sale.sendings
      }
    },
    customer () {
      if (this.sale.customer) {
        return this.sale.customer.tradename
      } else {
        return this.$t('sale.error')
      }
    },
    status_display_sendings () {
      if (this.sale.status_display_sendings) {
        return this.sale.status_display_sendings
      }
    },
    status_color () {
      return this.sale.status_display_sendings === 'Envio Completo' ? 'rgb(23, 201, 100)' : 'rgb(255, 130, 0)'
    }
  },
  methods: {
    ...mapActions([
      'setModalVisible'
    ]),
    showSendingDetails (record) {
      this.id = record.id
      this.setModalVisible(true)
    }
  }
}
</script>

<style lang="scss" scoped>
.table {
  padding-left: 0 !important;
  .vm-table-text {
    padding-left: 0 !important;
  }
}

.information__wrapper {
  .card__wrapper {
    padding: 15px;
  }
  .card {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px !important;
    height: 100% !important;
    .card-body {
      padding: 10px !important;
      width: 100%;
      height: 100%;
    }
  }
}

.card-flex2 {
  position: relative;
  display: flex;
  flex-direction: column;
}

.card {
  padding: 10px !important;
  height: 100% !important;
  .card-body {
    padding: 10px !important;
    width: 100%;
    height: 100%;
  }
}

.heading_title {
  h4 {
    span {
      color: #026481;
    }
  }
}

.input__wrapper,
.actions__wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}

.status__absolute {
  padding: 10px;
  position: absolute;
  top: 5px;
  left: 5px;
  border-radius: 0.5em;
  span {
    color: #fff;
    font-weight: bold;
  }
}
</style>
